import { z } from 'zod';

/**
 * Schema allows only 6 characters, which can be letters or digits.
 */
export const schemaAntragsnummer = z.string().min(1);

export type SchemaAntragsnummer = z.infer<typeof schemaAntragsnummer>;
